import type { Options } from 'ky'
import type { GetFaqsCategoriesResponse, GetFaqsResponse } from '@/types/faqs'
import { httpClient } from '@/utils/http'

export const faqsService = {
  getList: (options?: Options) =>
    httpClient.get('faqs', options).json<GetFaqsResponse>(),
  getCategories: (options?: Options) =>
    httpClient
      .get('faqs/categories', options)
      .json<GetFaqsCategoriesResponse>(),
}
